import styled, { css } from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    margin: 30px 20px 50px 20px;
    position: relative;
`;

const Line = styled.div<{
    $firstComplete: boolean;
    $secondComplete: boolean;
}>`
    height: 2px;
    background-color: #ccc;
    position: relative;
    
    ${({ $firstComplete, $secondComplete }) => $firstComplete && !$secondComplete && css`
        background: linear-gradient(to right, ${theme.primaryColor} 50%, #ccc 50%);
    `}

    ${props => props.$secondComplete && css`
        background-color: ${theme.primaryColor};
    `}
`;

const Marker = styled.div<{
    $filled: boolean;
    $outlined: boolean;
}>`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 20px;

    
    small {
        font-size: 11px;
        font-weight: 600;
        color: #ccc;
        margin-top: 5px;

        ${props => (props.$filled || props.$outlined) && css`
            font-weight: 700;
            color: ${theme.primaryColor};
        `}
    }

    div {
        color: #fff;
        width: 35px;
        height: 35px;
        line-height: 35px;
        font-size: 20px;
        font-weight: 700;
        color: #ccc;
        text-align: center;

        background-color: ${theme.white};
        border: 2px solid #ccc;
        border-radius: 50%;

        svg {
            margin-top: 5px;
        }

        ${props => props.$filled && !props.$outlined && css`
            background-color: ${theme.primaryColor};
            color: ${theme.white};
            border: 2px solid ${theme.primaryColor};
        `}

        ${props => props.$outlined && css`
            background-color: ${theme.white};
            color: ${theme.primaryColor};
            border: 2px solid ${theme.primaryColor};
        `}

        &:hover{
            -moz-transform: scale(1.2);
            -webkit-transform: scale(1.2);
            -o-transform: scale(1.2);
            -ms-transform: scale(1.2);
            transform: scale(1.2);
            -webkit-transition: all 300ms ease;
            -moz-transition: all 300ms ease;
            -ms-transition: all 300ms ease;
            -o-transition: all 300ms ease;
            transition: all 300ms ease;
        }
    }
`;

const MarkerRecipient = styled(Marker)`
    top: -20px;
    right: calc(100% - 25px);
`;

const MarkerTemplate = styled(Marker)`
    top: -20px;
    left: calc(50% - 12.5px);
`;

const MarkerResume = styled(Marker)`
    top: -20px;
    left: calc(100% - 25px);
`;

export { Container, Line, MarkerRecipient, MarkerResume, MarkerTemplate };